/**
 * Simple analytics tracking for conversion events.
 * Uses web-vitals for performance + custom event tracking.
 * Events are logged to console in dev, can be extended to any analytics provider.
 */

type TrackEvent = {
  category: string;
  action: string;
  label?: string;
  value?: number;
};

const isDev = import.meta.env.DEV;

export function trackEvent({ category, action, label, value }: TrackEvent) {
  if (isDev) {
    console.log(`[Analytics] ${category} / ${action}`, label ? `— ${label}` : "", value ?? "");
  }

  // Google Analytics 4 (if gtag is present)
  if (typeof window !== "undefined" && (window as any).gtag) {
    (window as any).gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
    });
  }
}

// Pre-built conversion events
export const analytics = {
  ctaClick: (ctaName: string) =>
    trackEvent({ category: "CTA", action: "click", label: ctaName }),

  formSubmit: (formName: string) =>
    trackEvent({ category: "Form", action: "submit", label: formName }),

  formError: (formName: string, error: string) =>
    trackEvent({ category: "Form", action: "error", label: `${formName}: ${error}` }),

  pageView: (page: string) =>
    trackEvent({ category: "Page", action: "view", label: page }),

  planSelect: (plan: string) =>
    trackEvent({ category: "Pricing", action: "select_plan", label: plan }),

  demoClick: () =>
    trackEvent({ category: "CTA", action: "click", label: "demo_live" }),

  galleryTabClick: (sector: string) =>
    trackEvent({ category: "Gallery", action: "tab_click", label: sector }),
};
